import * as React from 'react';
import ReactPlayer from 'react-player/lazy';

import { TMediaVideo } from '../../types';

export const YoutubePlayer: React.FC<TMediaVideo> = ({ src }) => {
  return <ReactPlayer data-testid="GalleryReactPlayer" url={src} width="100%" height="100%" controls playing />;
};
